module.exports = __webpack_public_path__ + "static/media/07.27f49da7.jpg";